import React, { useState, useEffect, useCallback } from 'react';
import PropTypes from 'prop-types';
import Report from '../../../Report/Report';

const StatisticsTable = ({
    data: propData,
    headerName: propHeaderName,
    loading: propLoading,
    order: propOrder,
    sort: propSort,
    metrics: propMetrics,
    keysMetric: propKeysMetric,
    onAction
}) => {
    const [data, setData] = useState(propData);
    const [headerName, setHeaderName] = useState(propHeaderName);
    const [loading, setLoading] = useState(propLoading);
    const [order, setOrder] = useState(propOrder);
    const [sort, setSort] = useState(propSort);
    const [metrics, setMetrics] = useState(propMetrics);
    const [keysMetric, setKeysMetric] = useState(propKeysMetric);
    const [isSorting] = useState(true);
    const [isTableFirst] = useState(false);
    const [tableHtml, setTableHtml] = useState(propData || '');

    // Sync with props changes
    useEffect(() => {
        setData(propData);
        setHeaderName(propHeaderName);
        setLoading(propLoading);
        setOrder(propOrder);
        setSort(propSort);
        setMetrics(propMetrics);
        setKeysMetric(propKeysMetric);
        setTableHtml(propData || '');
    }, [propData, propHeaderName, propLoading, propOrder, propSort, propMetrics, propKeysMetric]);

    const handleSort = useCallback((sortData) => {
        if (onAction) {
            onAction(sortData);
        }
    }, [onAction]);

    return (
        <Report
            data={data}
            tableHtml={tableHtml}
            headerName={headerName}
            metrics={metrics}
            isTableFirst={isTableFirst}
            isTableLast={true}
            isSorting={isSorting}
            keysMetric={keysMetric}
            sort={sort}
            order={order}
            onAction={handleSort}
            onSort={handleSort}
            tableWrapperClass={{
                'table-responsive_compact-report': true
            }}
            loading={loading}
        />
    );
};

StatisticsTable.propTypes = {
    data: PropTypes.string,
    headerName: PropTypes.array,
    loading: PropTypes.bool,
    order: PropTypes.string,
    sort: PropTypes.string,
    metrics: PropTypes.string,
    keysMetric: PropTypes.array,
    onAction: PropTypes.func
};

StatisticsTable.defaultProps = {
    data: '',
    headerName: null,
    loading: false,
    order: 'desc',
    sort: null,
    metrics: null,
    keysMetric: [],
    onAction: () => {}
};

export default StatisticsTable;
